import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

const MODAL_ID = '#application-global-modal'

/* To use the application modal do the following:
  1. Update its content by using 'application_modal_content' as a key. See views/items/consolidations/modal for reference
  2. From another controller, call the 'modal-content-loaded' event. For reference, look at app/javascript/controllers/rma_modal_opener_controller file
*/
export default class extends Controller {
  initialize() {
    this.modal = new Modal(MODAL_ID)
  }

  openModal() {
    this.modal.show()
  }
}
